import type { ParameterTypeEnum } from './OrderStrategy.types';
import type { OrdTypeEnum, PresenceEnum } from './types';

/**
 * WLOrderStrategy and WLOrderStrategyParameter represent the structure of order strategies returned by the WL APIs.
 * the OrderStrategy wrapper should generally be used instead.
 */
export interface WLOrderStrategyParameter {
  Description: string;
  DisplayName: string;
  Name: string;
  Presence: PresenceEnum;
  Type: ParameterTypeEnum;
}

export interface WLOrderStrategy {
  Name: string;
  Group: string;
  Parameters: WLOrderStrategyParameter[];
  Description: string;
  DisplayName: string;
  OrdType: OrdTypeEnum;
}

export const WLParameterKeysEnum = {
  LimitPrice: 'LimitPrice',
  EndTime: 'EndTime',
  StartTime: 'StartTime',
  ErrorAction: 'ErrorAction',
  ClipSize: 'ClipSize',
  ClipInterval: 'ClipInterval',
  Variance: 'Variance',
} as const;
export type WLParameterKeysEnum = (typeof WLParameterKeysEnum)[keyof typeof WLParameterKeysEnum];

export type WhitelabelParametersFormState = {
  [WLParameterKeysEnum.LimitPrice]?: string;
  [WLParameterKeysEnum.StartTime]?: string;
  [WLParameterKeysEnum.EndTime]?: string;
  [WLParameterKeysEnum.ErrorAction]?: string;
  [WLParameterKeysEnum.ClipSize]?: string;
  [WLParameterKeysEnum.ClipInterval]?: string;
  [WLParameterKeysEnum.Variance]?: string;
  [key: string]: unknown;
};
